<template>
  <v-app>
    <slot />
  </v-app>
</template>

<script>
export default {
  name: 'Auth',
};
</script>

<style scoped>

</style>
